import { render } from "./ShopMeal.vue?vue&type=template&id=6e8c03d6&ts=true"
import script from "./ShopMeal.vue?vue&type=script&lang=ts"
export * from "./ShopMeal.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__